var ChipsModule = (function () {
    function ChipsModule() {
    }
    return ChipsModule;
}());
export { ChipsModule };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/chips/chips.module.ts.pre-build-optimizer.js